import { render, staticRenderFns } from "./ElderResidentsByGender.vue?vue&type=template&id=337d5b36&scoped=true&"
import script from "./ElderResidentsByGender.vue?vue&type=script&lang=js&"
export * from "./ElderResidentsByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d5b36",
  null
  
)

export default component.exports